import { useState } from 'react'
import { toast } from 'react-toastify'

import { axiosInstance } from '../helpers'
import { Report } from '../types/analytics'

export const useReports = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [reportList, setReportList] = useState<Report[]>([])

    const getReportList = async () => {
        setIsLoading(true)
        try {
            const res = await axiosInstance.get('stats/tenant-damage-report/')
            const reports: Report[] = res.data
            setReportList(reports)
            setIsLoading(false)
            return reports
        } catch (e) {
            toast.error('Error getting reports')
            setIsLoading(false)
            return Promise.reject(e)
        }
    }

    const markReportAsViewed = async (reportId: number) => {
        try {
            axiosInstance.post(
                `stats/tenant-damage-report/${reportId}/mark_as_viewed/`,
            )

            setReportList(
                reportList.map((report) => {
                    if (report.id === reportId) {
                        return { ...report, tenant_viewed: true }
                    }
                    return report
                }),
            )
        } catch (e) {}
    }

    return {
        isLoading,
        reportList,
        getReportList,
        markReportAsViewed,
    }
}
